import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useInView, reveal } from '../home/motion';
import { useT } from '../../i18n/LanguageContext';

export default function MethodHero() {
  const theme = useTheme();
  const navigate = useNavigate();
  const t = useT();
  const { ref, visible } = useInView();

  return (
    <Box sx={{ bgcolor: theme.home.paper, pt: { xs: 8, md: 12 }, pb: { xs: 6, md: 8 }, position: 'relative', overflow: 'hidden' }}>
      <Box sx={{ position: 'absolute', inset: 0, backgroundImage: theme.home.grain, opacity: 0.5, pointerEvents: 'none' }} />
      <Box ref={ref} sx={{ maxWidth: 820, mx: 'auto', px: { xs: 3, md: 5 }, textAlign: 'center', position: 'relative' }}>
        <Typography variant="overline" sx={{ color: theme.home.coralText, ...reveal(visible) }}>
          {t('method.hero.eyebrow')}
        </Typography>
        <Typography variant="h1" sx={{
          mt: 1.5, color: theme.home.ink, fontSize: { xs: '2.4rem', md: '3.6rem' }, ...reveal(visible, 0.08),
        }}>
          {t('method.hero.title')}
        </Typography>
        <Typography sx={{
          mt: 3, color: theme.home.inkMuted, fontSize: { xs: '1.1rem', md: '1.3rem' }, lineHeight: 1.65,
          maxWidth: 640, mx: 'auto', ...reveal(visible, 0.16),
        }}>
          {t('method.hero.body')}
        </Typography>
        <Box sx={{ mt: 4.5, display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', ...reveal(visible, 0.24) }}>
          <Button
            variant="contained" size="large" endIcon={<ArrowForwardIcon />}
            onClick={() => navigate('/signup')}
            sx={{ px: 3.5, py: 1.4, borderRadius: 999, bgcolor: theme.home.coralText, '&:hover': { bgcolor: theme.home.coralHover } }}
          >
            {t('method.hero.ctaPrimary')}
          </Button>
          <Button
            variant="outlined" size="large"
            onClick={() => navigate('/pricing')}
            sx={{ px: 3.5, py: 1.4, borderRadius: 999, borderColor: theme.home.ink, color: theme.home.ink }}
          >
            {t('method.hero.ctaSecondary')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
